import { render, staticRenderFns } from "./WTable.vue?vue&type=template&id=0d338b0c&scoped=true&"
import script from "./wTable.ts?vue&type=script&lang=ts&"
export * from "./wTable.ts?vue&type=script&lang=ts&"
import style0 from "./WTable.vue?vue&type=style&index=0&id=0d338b0c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d338b0c",
  null
  
)

export default component.exports